import { UserConfigurationModel } from '../models/user-model';

export const AI_ALLOWED_CONFIG_TYPE = 'IsAIAllowed';
export const AI_ALLOWED_CONFIG_KEY = 'IsAIAllowed';

/**
 * Whether AI features are on for this user. Opt-out, not opt-in: a user who has never opened
 * AI Preferences has no row at all, and that must mean allowed — only an explicit "Don't allow"
 * (value "False") turns it off. This is now the one switch every AI feature checks (the Mealy
 * panel, its nav entry and route, Auto-fill on the AP form, and the Backend/Agent enforcing the
 * same rule server-side), not just the "Create Bill" row it started as.
 */
export function isAiAllowed(
  configurations: UserConfigurationModel[] | null | undefined
): boolean {
  const config = configurations?.find((c) => c.key === AI_ALLOWED_CONFIG_KEY);
  if (!config) {
    return true;
  }
  if (typeof config.value === 'boolean') {
    return config.value;
  }
  return String(config.value).toLowerCase() !== 'false';
}
